import {useCallback} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {Drop} from '../../grpc_client/grips/protos/shared/drop';
import {DROPS_BASE_PATH} from '../../ui/Drops/utils/helper';
import {getProductUrlFromParts} from '../url-utils';

export default function useDropClickHandler(drop?: Drop) {
  const history = useHistory();
  const params = useParams<{droptype: string}>();
  const onDropClick = useCallback(() => {
    if (drop?.singleProductId) {
      return history.push(
        getProductUrlFromParts({
          brandName: drop?.brandName,
          productId: drop?.singleProductId,
        }),
      );
    }

    return history.push(`${DROPS_BASE_PATH}/${params?.droptype}/${drop?.id}`);
  }, [history, params?.droptype, drop]);

  return onDropClick;
}
